import { Directive, HostListener, Input } from '@angular/core';
import { AtsCsv } from '@ats/utility';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
	standalone: true,
	selector: 'button[cm-csv-export], a[cm-csv-export]',
})
export class CmCsvExportDirective {
	@Input({ required: true }) headers!: string[];
	@Input({ required: true }) data!: any[];
	@Input() fileName: string = 'CSV-Export.csv';

	@HostListener('click', ['$event.target'])
	onClick(_: any) {
		AtsCsv.download(AtsCsv.createBlob(this.data, this.headers), this.fileName);
	}
}
